import React, { useState, useEffect, useRef } from 'react';
import { default as T } from 'services/i18n/Translate';
import Icon from 'components/Icons/Icon';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';
import Loading from 'components/Loading';
import './Countdown.scss'

const Countdown = ({ setTriggerCall, countValue, activeProcess, delayCall, setDelayCall, progressArray }) => {
  const [count, setCount] = useState(countValue);
  const [initialising, setInitialising] = useState(delayCall ?? false);
  const [changeInProgress, setChangeInProgress] = useState(false);

  const prevProgressLengthRef = useRef(progressArray?.length ?? 0);

  useEffect(() => {
    const currentLength = progressArray?.length ?? 0;
    const prevLength = prevProgressLengthRef.current;

    if (currentLength !== prevLength) {
      setChangeInProgress(prev => prev + 1);
      prevProgressLengthRef.current = currentLength;
    }
  }, [progressArray]);

  useEffect(() => {
    setCount(countValue);
  }, [countValue]);

  useEffect(() => {
    if (delayCall) {
      setTimeout(() => {
        setDelayCall(null);
        setInitialising(false);
      }, 1000)
    }

    const interval = setInterval(() => {
      setCount((prev) => (prev <= 1 ? countValue : prev - 1));
    }, 1000);
 
    return () => clearInterval(interval);
  }, [countValue, delayCall, activeProcess]);

  useEffect(() => {
    if (!delayCall) {
      if (count === countValue) { 
        setTriggerCall(true); 
      };
      if (changeInProgress) { 
        setTriggerCall(true); 
      };
      count === (countValue - 1) && setTriggerCall(false);
    }
  }, [count, countValue, delayCall, activeProcess, initialising, changeInProgress]);
  
  return (
    <>
      <div className='d-flex align-items-center countdown-wrapper'>
        <span className={`${initialising ? '' : 'show'} mr-1`}>
          {initialising ? 
            <span className='d-flex align-items-center flex-row flex-nowrap w-100'>
              <span className='d-flex align-items-center flex-row flex-nowrap w-100'>Getting Status</span>
              <Loading />
            </span> 
            : 'Live Refresh'
          }
        </span>
        <Tooltip
          className={initialising ? 'hide-section' : 'show'}
          placement='top'
          description={
            <div className='d-flex flex-column'>
              <div className='pb-2 text-left'>
                {activeProcess ?
                  <span className='text-left'>
                    Active process detected. Refresh adjusted to 5 seconds
                  </span>
                : 
                  <span className='text-left'>
                    No active processes detected. Refresh set to 60 seconds
                  </span>
                }
              </div>
              <span className='text-left'>
                <T>Next Refresh</T>:{' '}
                {count.toString()}
              </span>
            </div>
          }
        >
          <span className={initialising ? 'hide-section' : 'show'}>
            <Icon icon='info' />
          </span>
        </Tooltip>
      </div>
    </>
  )
};

export default React.memo(Countdown);